import React, { useMemo } from 'react'
import { useSelector } from 'react-redux'

import { A4_PORTRAIT } from 'src/views/Management/Reports/types'
import { ApplicationState } from 'src/store'
import { Empty } from 'src/components/Ant'
import { R4Data } from 'src/store/ducks/reports/types'

import { Footer, OptionsBar, TitleReport } from '..'
import { SectionHeader, TableDetail } from './components'
import { WrapPageContent, WrapPage } from '../../styles'
import { WrapTableDiv } from './styles'

enum mesures {
  PAGE_HEIGHT = 1020,
  SECTION_HEADER = 96,
  SECTION_TITLE = 65,
  SINGLE_REGISTER = 11.8,
  SINGLE_REGISTER_PADDINGS = 10,
  TABLE_HEADER = 60
}

function calculatePageRecords(index: number, data: R4Data[]) {
  let records = 0
  if (index >= data.length) {
    return 0
  }

  let availableSpace =
    mesures.PAGE_HEIGHT -
    mesures.SECTION_TITLE -
    mesures.SECTION_HEADER -
    mesures.TABLE_HEADER

  for (let item of data.slice(index)) {
    const nexSize = Math.floor(
      Math.max(item.owner.length, item.traveler.length) *
        mesures.SINGLE_REGISTER +
        mesures.SINGLE_REGISTER_PADDINGS
    )
    if (nexSize <= availableSpace) {
      availableSpace -= nexSize
      records++
    } else {
      return records
    }
  }

  return records
}
function R4() {
  const {
    reports: {
      reportsResources: {
        R4Data: { data }
      }
    }
  } = useSelector((state: ApplicationState) => ({
    reports: state.reports
  }))

  const pages = useMemo(() => {
    if (!data.length && !data.length) {
      return [
        [
          <TitleReport title="web.report.4.title" />,
          <SectionHeader />,
          <Empty />
        ]
      ]
    }

    const tempPages: JSX.Element[][] = []

    let index = 0
    // Make pages //
    do {
      const page: JSX.Element[] = []
      page.push(<TitleReport title="web.report.4.title" />)
      page.push(<SectionHeader />)

      const records = calculatePageRecords(index, data)
      const maxRecordsPossible = data.slice(index, index + records)
      page.push(
        <WrapTableDiv>
          <TableDetail dataSource={maxRecordsPossible} />
        </WrapTableDiv>
      )
      index += records
      tempPages.push(page)
    } while (index < data.length)
    return tempPages
  }, [data])

  return (
    <>
      <OptionsBar />
      {pages.map((item, index) => (
        <WrapPage key={index} className="print" pageShape={A4_PORTRAIT}>
          <WrapPageContent>
            {item.map((t, i) => (
              <React.Fragment key={i}>{t}</React.Fragment>
            ))}
          </WrapPageContent>
          <Footer pagination={{ x: index + 1, y: pages.length }} />
        </WrapPage>
      ))}
    </>
  )
}

export default R4
